import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Plan",
    description:
      "We collaborate with you to better understand your needs, streamlining existing and future Web3 plans.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Design",
    description:
      "We craft a user-friendly and visually appealing user interface that reflects your business identity.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Build",
    description:
      "Our web 3.0 developers convert the design into a functional application utilizing a recent tech stack.",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Test",
    description:
      "To ensure your app works properly, rigorous testing is conducted to identify and rectify any bugs.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Launch",
    description:
      "Your mobile app is ready to make its debut in various stores, reaching its intended audience.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Maintenance",
    description:
      "Our team provides monitoring and post-launch support to keep your app updated with Web3 solutions.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 tekrevol_gray_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Our Web3 App Development <span>Workflow</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              As a top-notch Web3 development company, we simplify the
              development process by thoroughly researching market dynamics and
              trends while customizing each project for maximum success. Here is
              our Web3 application development process:
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
